import React from 'react'
import Error from 'next/error'
import FormazioneCorsiListing from 'react-components/organisms/FormazioneCorsiListing/FormazioneCorsiListing'
import { api } from 'utils'
import Breadcrumbs from 'components/atomic/Breadcrumbs'
import MetaSeo from 'components/atomic/MetaSeo'
import { PAGINEDETAIL, FORMAZIONECORSI, GETFILTERS, GETFILTERID } from 'utils/endpoint'
import { useTrans } from 'hooks'
const FormazioneCorsiFiltered = ({ page, statusCode, filters = [], corsiFormazione = [] }) => {
  if (!page) return <Error statusCode={statusCode} />

  const t = useTrans()

  const background = page.main_image
    ? { backgroundImage: `url(${page.main_image})` }
    : { backgroundColor: `#e6f1fe` }

  return (
    <>
      <MetaSeo seo={page.seo} />
      <main className="formazione-corsi-page">
        <div className="w-container-fluid u-background-image" style={background}>
          <div className="w-container">
            <Breadcrumbs breadcrumbs={page.breadcrumbs} />
          </div>

          <div className="formazione-corsi-page__header">
            <div className="w-container">
              <h1 className="formazione-corsi-page__header__title">{t('Formazione Viva')}</h1>
              <h1 className="formazione-corsi-page__header__subtitle">
                {t(
                  'Un’offerta ricca e gratuita per la scuola primaria: pratica didattica, convegni con esperti, laboratori, aggiornamento professionale e molto altro.'
                )}
              </h1>
            </div>
          </div>
        </div>
        <div className="formazione-corsi-page__content u-bg-white">
          <div className="w-container">
            <p className="formazione-corsi-page__content__abstract">
              <FormazioneCorsiListing corsiFormazione={corsiFormazione} filters={filters} />
            </p>
          </div>
        </div>
      </main>
    </>
  )
}

export const getServerSideProps = async ({ params }) => {
  const headers = params.req?.headers?.cookie
    ? { cookie: params.req.headers.cookie, anteprima: params.req.headers.anteprima || false }
    : undefined

  try {
    const pageResponse = await api.get(PAGINEDETAIL, {
      params: {
        chiave: 'formazione-corsi-all-filtered',
      },
      headers,
    })
    const page = await pageResponse.data
    let newDefaultContent = null

    const toolbarProps = { toolbarPage: page }
    const slug = `${params.slug}`
    const filtroIdResponse = await api.get(`${FORMAZIONECORSI}${GETFILTERID}`, {
      params: {
        slug: slug,
      },
      headers,
    })

    const filtroId = await filtroIdResponse.data

    const corsoFormazioneFilteredResponse = await api.get(`${FORMAZIONECORSI}`, {
      params: {
        attributi__valore_attributo_id__exact: filtroId[0],
      },
      headers,
    })
    const corsiFormazione = await corsoFormazioneFilteredResponse.data

    const corsoFormazioneFiltriResponse = await api.get(`${FORMAZIONECORSI}${GETFILTERS}`)
    const filters = await corsoFormazioneFiltriResponse.data
    return {
      props: { page, newDefaultContent, ...toolbarProps, filters, corsiFormazione },
    }
  } catch (error) {
    console.log(error)
    if (params.res) {
      params.res.statusCode = 404
    }
    return { props: { statusCode: 404 } }
  }
}

export default FormazioneCorsiFiltered
